<template lang="pug">
  v-card.pa-4.mx-auto(
    max-width="1200"
  )

    v-toolbar-title Настройки

    v-row(align="center").mt-3

      v-col.d-flex.align-center(cols="12" sm="6" lg="4")
        v-select.mr-auto(
          :items="languages"
          :value="locale"
          label="Перевод"
          flat
          hide-details
          outlined
          dense
          background-color="white"
          @change="onChangeLanguage"
        )

      v-col.d-flex.align-center(cols="12" sm="6" lg="4")
        PublishDateStartPicker(v-model="dateStartModel")

      v-col.d-flex.align-center(cols="12" sm="6" lg="4")
        PublishDateEndPicker(v-model="dateEndModel")

      v-col.d-flex.align-center(cols="12" sm="6" lg="4")
        v-checkbox.mt-0.pt-0(
          v-model="activeModel"
          label="Показывать на сайте"
          hide-details
          dense
        )

    v-card.mx-auto(
      max-width="1200"
      flat
      color="transparent"
    )
      v-row.mb-0(align="center") Необходимо заполнить одно из полей. Если страна будет добавлена в обе группы, то в этой стране баннер отображаться будет.
      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-select.headline(
            v-model="countriesIncludedModel"
            :items="countriesName"
            attach
            chips
            label="Страны, где показывать. "
            multiple
          )

      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-select.headline(
            v-model="countriesExcludedModel"
            :items="countriesName"
            attach
            chips
            label="Страны, где НЕ показывать"
            multiple
          )

    v-card.mx-auto(
      max-width="1200"
      flat
      color="transparent"
    )
      v-row.mb-0(align="center") Необходимо заполнить одно из полей. Если страна будет добавлена в обе группы, то на этом сайте баннер отображаться будет.
      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-select.headline(
            v-model="sitesIncludedModel"
            :items="sitesName"
            attach
            chips
            label="Сайты, где показывать. "
            multiple
          )

      v-row.mb-0(align="center")
        v-col.d-flex(cols="12")
          v-select.headline(
            v-model="sitesExcludedModel"
            :items="sitesName"
            attach
            chips
            label="Сайты, где НЕ показывать"
            multiple
          )

</template>

<script>
import PublishDateStartPicker from '../../../components/controls/PublishDateStartPicker'
import PublishDateEndPicker from '../../../components/controls/PublishDateEndPicker'

/**
 * @displayName Post settings
 */
export default {
  data() {
    return {
      countries: [
        {
          name: 'Россия',
          id: 1,
        },
        {
          name: 'Украина',
          id: 2,
        },
        {
          name: 'Беларусь',
          id: 3,
        },
        {
          name: 'Казахстан',
          id: 4,
        },
        {
          name: 'Азербайджан',
          id: 5,
        },
        {
          name: 'Армения',
          id: 6,
        },
        {
          name: 'Грузия',
          id: 7,
        },
        {
          name: 'Киргизия',
          id: 8,
        },
        {
          name: 'Молдавия',
          id: 9,
        },
        {
          name: 'Таджикистан',
          id: 10,
        },
        {
          name: 'Туркмения',
          id: 11,
        },
        {
          name: 'Монголия',
          id: 12,
        },
        {
          name: 'США',
          id: 13,
        },
        {
          name: 'Мексика',
          id: 14,
        },
      ],
      sites: [
        {
          name: 'awc',
          id: 'awc',
        },
        {
          name: 'wwp',
          id: 'wwp',
        },
        {
          name: 'b2reach',
          id: 'b2reach',
        },
        {
          name: 'spl',
          id: 'spl',
        },
        {
          name: 'smartproduct',
          id: 'smartproduct',
        },
      ],
    }
  },
  components: {
    PublishDateStartPicker,
    PublishDateEndPicker,
  },
  props: {
    dateStart: {
      type: Date,
      default: new Date()
    },
    dateEnd: {
      type: Date,
      default: new Date()
    },
    /**
     * Show or not a post on the website
     */
    active: {
      type: Boolean,
      default: false,
    },
    locale: {
      type: String,
      default: 'ru',
    },
    countriesExcluded: {
      type: String,
      default: '',
    },
    countriesIncluded: {
      type: String,
      default: '',
    },
    sitesExcluded: {
      type: String,
      default: '',
    },
    sitesIncluded: {
      type: String,
      default: '',
    },
    /**
     * Post language select
     */
    languages: {
      type: Array,
      default: () => [
        {
          text: 'Russian',
          value: 'ru',
        },
      ],
    },
  },
  methods: {
    onChangeLanguage(val) {
      /**
       * Triggers when language changes
       *
       * @property {string|object} val
       */
      this.$emit('languageChanged', val)
    },
    getCountryCode(name) {
      for (let i = 0; i < this.countries.length; i++) {
        if (name === this.countries[i].name) {
          return this.countries[i].id
        }
      }
    },
    getCountry(id) {
      for (let i = 0; i < this.countries.length; i++) {
        if (id === this.countries[i].id.toString()) {
          return this.countries[i].name
        }
      }
    },
    getSiteCode(name) {
      for (let i = 0; i < this.sites.length; i++) {
        if (name === this.sites[i].name) {
          return this.sites[i].id
        }
      }
    },
    getSite(id) {
      for (let i = 0; i < this.sites.length; i++) {
        if (id === this.sites[i].id.toString()) {
          return this.sites[i].name
        }
      }
    },
  },
  computed: {
    countriesName() {
      return this.countries.map((country) => {
        return country.name
      })
    },
    countriesExcludedModel: {
      get() {
        return this.countriesExcluded.split(',').map((code) => {
          return this.getCountry(code)
        }).filter((el) => {
          return el != null
        })
      },

      set(val) {
        this.$emit('countriesExcludedChanged', val.map((country) => {
          return this.getCountryCode(country)
        }).join(','))
      },
    },
    countriesIncludedModel: {
      get() {
        return this.countriesIncluded.split(',').map((code) => {
          return this.getCountry(code)
        }).filter((el) => {
          return el != null
        })
      },

      set(val) {
        this.$emit('countriesIncludedChanged', val.map((country) => {
          return this.getCountryCode(country)
        }).join(','))
      },
    },
    sitesName() {
      return this.sites.map((site) => {
        return site.name
      })
    },
    sitesExcludedModel: {
      get() {
        return this.sitesExcluded.split(',').map((code) => {
          return this.getSite(code)
        }).filter((el) => {
          return el != null
        })
      },

      set(val) {
        this.$emit('sitesExcludedChanged', val.map((site) => {
          return this.getSiteCode(site)
        }).join(','))
      },
    },
    sitesIncludedModel: {
      get() {
        return this.sitesIncluded.split(',').map((code) => {
          return this.getSite(code)
        }).filter((el) => {
          return el != null
        })
      },

      set(val) {
        this.$emit('sitesIncludedChanged', val.map((site) => {
          return this.getSiteCode(site)
        }).join(','))
      },
    },
    dateStartModel: {
      get() {
        return this.dateStart
      },

      set(val) {
        /**
         * Triggers when the date changes on a publish date picker
         *
         * @property {string} val
         */
        this.$emit('dateStartChanged', val)
      },
    },
    dateEndModel: {
      get() {
        return this.dateEnd
      },

      set(val) {
        /**
         * Triggers when the date changes on a publish date picker
         *
         * @property {string} val
         */
        this.$emit('dateEndChanged', val)
      },
    },
    activeModel: {
      get() {
        return this.active
      },

      set(val) {
        /**
         * Triggers when showing post state changes
         *
         * @property {boolean} val
         */
        this.$emit('activeChanged', JSON.parse(val))
      },
    },
  },
}
</script>
